import React from 'react'
import { LabeledInput } from '../Reusable/Input';
import { Flex, LightContainer } from './Container';
import { addressObjectToMultiLineStr } from '../../Utils/util';

const PaymentMethodDetails = ({ record }) => {
    var { bankDetail, recipient, remittanceInfo } = record
    bankDetail = bankDetail || {}

    const { accountNumber, routingNumber, accountType, checkDeliveryType, addressOnAccount } = bankDetail

    return (
        <LightContainer fullWidth>
            <Flex start fullWidth wrap gap='12px'>
                {
                    accountNumber &&
                    <LabeledInput
                        label='Account Number'
                        nomargin
                        type='read-only'
                        value={accountNumber}
                        width='248px'
                    />
                }

                {
                    routingNumber &&
                    <LabeledInput
                        label='Routing Number'
                        nomargin
                        type='read-only'
                        value={routingNumber}
                        width='248px'
                    />
                }

                {
                    accountType &&
                    <LabeledInput
                        label='Account Type'
                        nomargin
                        type='read-only'
                        value={accountType}
                        width='248px'
                    />
                }

                {
                    checkDeliveryType &&
                    <LabeledInput
                        label='Delivery Type'
                        nomargin
                        type='read-only'
                        value={checkDeliveryType == 'PostalMail' ? 'Postal Mail' : checkDeliveryType}
                        width='248px'
                    />
                }

                {
                    checkDeliveryType && addressOnAccount &&
                    <LabeledInput
                        label='Delivery Address'
                        nomargin
                        type='read-only'
                        value={addressObjectToMultiLineStr(addressOnAccount)}
                        width='248px'
                    />
                }

                {
                    (checkDeliveryType == 'Email') &&
                    <LabeledInput
                        label='Delivery Address'
                        nomargin
                        type='read-only'
                        value={recipient.email}
                        width='248px'
                    />
                }
                {
                    remittanceInfo &&
                    <LabeledInput
                        type='read-only'
                        label="Remittance Information"
                        nomargin
                        value={remittanceInfo}
                        width='568px'
                    />
                }
            </Flex>
        </LightContainer>
    )
}

export default PaymentMethodDetails